import { Dayjs } from "dayjs";
import HttpClient from "../../../../core/HttpClient";
import { Authentication } from "@leedpulse-monorepo/classes";
import type { LastCallEntry } from "./getOverviewStats";

/**
 * Une page de la table « Appels » du tableau de bord.
 *
 * `getOverviewStats` ne porte que les 100 appels les plus récents de la
 * période : la table s'arrêtait donc à dix pages de dix, quel que soit le
 * nombre réel d'appels. Cette route sert les pages suivantes, avec exactement
 * la même mise en forme de ligne (`buildLastCalls` côté serveur). Le total
 * affiché reste `callsStats.handledCalls`, déjà calculé sur toute la période.
 */
async function getOverviewCalls(
    auth: Authentication | null,
    page: number,
    pageSize: number,
    period?: [Dayjs | null, Dayjs | null],
    subscriptionIds?: string[],
    exclude?: string[],
): Promise<LastCallEntry[]> {
    if (!auth) return [];

    const body: {
        period?: { from: number; to: number };
        subscriptionIds?: string[];
        exclude?: string[];
        page: number;
        pageSize: number;
    } = { page, pageSize };

    if (period && period[0] && period[1]) {
        body.period = {
            from: period[0].startOf('day').toDate().getTime(),
            to: period[1].endOf('day').toDate().getTime(),
        };
    }
    if (subscriptionIds && subscriptionIds.length > 0) {
        body.subscriptionIds = subscriptionIds;
    }
    if (exclude && exclude.length > 0) {
        body.exclude = exclude;
    }

    const response = await HttpClient.post('/leedflow/overview-calls', body, auth.token);
    return (response?.rows ?? []) as LastCallEntry[];
}

export default getOverviewCalls;
